<template>
    <div v-cloak class="transfer-right-body" id="cloudTransfer" v-if="transferPageShow" v-loading="loading"
        element-loading-background="rgba(0, 0, 0, 0.05)">
        <div class="task-top">
            <div class="task-top-position">
                <div class="transfer-name">{{ $t('language.leftBanner.cloudTransfer') }}</div>
                <div class="transfer-description">{{ $t('language.cloudTransfer.transferDescription') }}</div>
            </div>
        </div>
        <div class="task-middle">
            <div class="task-box-position">
                <div class="task-box" :class="boxFrom" @click="transferSourceDialogShow()">
                    <liteSelectView :data="liteSelectFromData" />
                    <el-scrollbar style="height:100%;">
                        <div class="task-operating"
                            v-if="(hasSelectItems == false && hasSelectItemsMore == false) || mulitDrives.length == 0">
                            <div :class="$i18n.locale == 'france' ? 'task-operating-none' : 'task-operating-name'">
                                {{ $t('language.cloudTransfer.from') }}</div>
                            <div class="task-operating-des">{{ $t('language.cloudTransfer.transferOperateFrom') }}</div>
                        </div>
                        <div class="task-main" v-if="hasSelectItems || mulitDrives.length == 1">
                            <div class="task-type task-icon" :class="mulitDrives[0].driveType + '_big'"></div>
                            <div class="task-catalog" :title="mulitDrives[0].formUrl">{{ mulitDrives[0].formUrl }}</div>
                        </div>
                        <div class="task-source-more" v-if="hasSelectItemsMore && mulitDrives.length > 1">
                            <div class="source-item" @mouseenter="hoverCurrent = index" @mouseleave="hoverCurrent = -1"
                                :key="index" v-for="(item, index) in mulitDrives">
                                <div class="item-formicon"
                                    :class="[item.appName ? 'icon ' + item.appName + '-small' : 'small-file', item.dir ? 'folder-small' : '', !item.dir && !item.appName ? matchfileType(item.name) + '-small' : '']">
                                </div>
                                <div class="item-url" :title="item.formUrl">{{ item.formUrl }}</div>
                                <div v-if="hoverCurrent == index" class="icon-util round-cancel round-cancel-position"
                                    @click.stop="removeItem(index, item.id)"></div>
                            </div>
                        </div>
                    </el-scrollbar>
                </div>
                <div class="task-box-middle">
                    <div class="arrow-position"></div>
                </div>
                <div class="task-box" :class="boxTo" @click="transferAimsDialogShow()">
                    <liteSelectView :data="liteSelectToData" />
                    <div class="task-operating" v-if="hasSelect">
                        <div class="task-operating-name">{{ $t('language.cloudTransfer.to') }}</div>
                        <div class="task-operating-des">{{ $t('language.cloudTransfer.transferOperateTo') }}</div>
                    </div>
                    <div class="task-main" v-if="!hasSelect">
                        <div class="task-type task-icon" v-bind:class="singleDrives.driveType + '_big'"></div>
                        <div class="task-catalog" :title="singleDrives.cloudCatalog">{{ singleDrives.cloudCatalog }}</div>
                    </div>
                </div>
            </div>
            <div class="definite-operating">
                <div style="position:relative;">
                    <div class="operating-options" @click="openOptionsDialog()">
                        <div class="icon-util setting" style="float:left;"></div>
                        <div class="operating-position">{{ $t('language.common.options') }}</div>
                    </div>
                    <div class="operating-schedule" @click="openSchduleDialog()" v-if="!$store.state.isLiteMode">
                        <div class="icon-util" @click.stop="checkedOpen()" :class="checkedSchedule ? 'check' : 'nocheck'"
                            style="float:left;"></div>
                        <div class="operating-position">{{ $t('language.common.schedule') }}</div>

                    </div>
                    <edit-input ref="editInput" :inputValue=inputValue :submitTaskName="submiTransfertName"></edit-input>
                    <button class="transfer-button" v-if="!checkedSchedule" @click="transferNow()">
                        <div class="icon transfer-icon-position cloudTransfer"></div>
                        <div style="float:left;">{{ $t('language.cloudTransfer.transferNow') }}</div>
                    </button>
                    <div class="schedule-button" v-if="checkedSchedule" @click.stop="transferAddTask()">
                        <div class="text-button-position">
                            <div class="icon transfer-task-position cloudTransfer"></div>
                            <div style="float:left;color:#fff;">{{ $t('language.cloudTransfer.addTaskOnly') }}</div>
                        </div>
                        <div class="more-button-position" @click.stop="addTaskIconShow()">
                            <div class="icon-util  transfer-up-position"
                                :class="addTaskShow ? 'transfer-up' : 'transfer-down'">
                            </div>
                        </div>
                    </div>
                    <div class="addTask" v-if="addTaskShow" @click.stop="addTransferNow()">
                        <div class="task-type-icon-min transfer-blue-min transfer-blue-position"></div>
                        <div style="float:left;">{{ $t('language.cloudTransfer.addTaskNow') }}</div>
                    </div>
                    <transition name="flow">
                        <div class="flow-icon" v-show="flowShow" id="transferFlow">
                            <div class="icon transfer-task-position cloudTransfer flow-icon-position"></div>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
        <div class="task-buttom"></div>
        <transferAimsDialog ref="transferAimsDialog"></transferAimsDialog>
        <transferSourceDialog ref="transferSourceDialog"></transferSourceDialog>
        <transferOptionsDialog ref="transferOptionsDialog"></transferOptionsDialog>
        <transferScheduleDialog ref="transferScheduleDialog" :schedules=pSchedules></transferScheduleDialog>
        <upgradeNewDialog ref="upgradeNewDialog"></upgradeNewDialog>
        <noticeDialog ref="noticeDialog"></noticeDialog>
        <remindBindEmailDialog ref="remindBindEmailDialog"></remindBindEmailDialog>
        <liteSelect ref="tranFromTree" :showCheckbox="false" :showFileNode="true" :showNewFolder="false" @selectDone="selectDoneFrom" />
        <liteSelect ref="tranToTree" :showCheckbox="false" :showFileNode="false" :showNewFolder="true" @selectDone="selectDoneTo" />
        <liteOptions ref="tranOptions" :data="liteOptionsData" @ok="okOptions" />
    </div>
</template>

<script>
import { Message } from "element-ui";
import requestUtils from '@/js/request_util.js';
//显示账号升级弹窗
import upgradeNewDialog from "@/components/popup/upgrade_popups/upgrade_account_new_popup";
import commonUtils from "@/js/workspace/common_util.js";
import transferAimsDialog from "@/components/popup/cloud_transfer_popups/task_single_popup";
import transferSourceDialog from "@/components/popup/cloud_transfer_popups/transfer_multi_popup";
import transferOptionsDialog from "@/components/popup/cloud_transfer_popups/transfer_options_popup";
import transferScheduleDialog from "@/components/popup/cloud_transfer_popups/task_schedule_popup";
import editInput from '@/components/common/input/edit_input';
import taskTransferUtils from '@/js/workspace/task_transfer_util.js';
import taskListUtils from "@/js/workspace/task_list_util.js";
import noticeDialog from "@/components/popup/cloud_transfer_popups/transfer_notice_popup";
import liteOptions from "@/components/workspace/lite_options";
import liteSelect from "@/components/workspace/lite_select";
import liteSelectView from "@/components/workspace/lite_select_view";
import remindBindEmailDialog from "@/components/popup/personal_center_popups/remind_bind_email_popup";
import commonstate from '@/js/constant.js';
export default {
    name: "cloudTransfer",
    components: {
        transferAimsDialog,
        transferSourceDialog,
        "edit-input": editInput,
        transferOptionsDialog,
        transferScheduleDialog,
        upgradeNewDialog,
        noticeDialog,
        liteOptions,
        liteSelect,
        liteSelectView,
        remindBindEmailDialog
    },
    data() {
        return {
            flowShow: false,
            transferPageShow: true,
            singleDrives: {},
            mulitDrives: [],
            hasSelect: true,
            hasSelectItemsMore: false,
            hasSelectItems: false,
            inputValue: commonUtils.getTaskTxt(this),
            checkedSchedule: false,
            hoverCurrent: -1,
            allLength: 0,
            folderType: 'small-file type-icon-position',
            fileType: 'icon type-drive-position',
            addTaskShow: false,
            pOptions: {
                replace: 2,
                isChar: 1,
                keepRoot: 1
            },
            pSchedules: {},
            boxFrom: '',
            boxTo: '',
            addTaskFlag: true,
            loading: false,
            liteSelectFromData: null,
            liteSelectToData: null,
            liteOptionsData: {
                listThread: commonUtils.getUser().vip ? 3 : 1,
                runThread: commonUtils.getUser().vip ? 10 : 2,
                email: '',
                cron: '',
                sameName: 'default',
                excludeNames: [],
                allowedExtensions: [],
            },
            createTasking: false,
        };
    },
    watch: {
        //监听任务列表，默认名称跟着变化
        '$store.state.taskListArr': function (newValue, oldValue) {
            let allTasklistData = this.$store.state.taskListArr;
            commonUtils.changeTaskNameLength(allTasklistData, this);
        },
    },
    created() {
        //初始化界面名称
        commonUtils.initPageName(this, 'cloudTransfer');
    },
    mounted() {
        //禁用拖拽功能
        commonUtils.dragDisAble('cloudTransfer', this);
    },
    methods: {
        okOptions(data) {
            this.liteOptionsData = data;
        },
        selectDoneFrom(data) {
            this.liteSelectFromData = data;
        },
        selectDoneTo(data) {
            this.liteSelectToData = data;
        },
        onDrag: function (e) {
            e.stopPropagation();
            e.preventDefault();
        },
        addTaskIconShow() {
            this.addTaskShow = !this.addTaskShow;
        },
        //提交传输任务名
        submiTransfertName() {
            if (this.$refs.editInput.value.length > 255) {
                this.$refs.editInput.value = this.$refs.editInput.oldNameValue;
                this.$toast({
                    text: this.$t('language.taskList.taskNameRule'),
                    type: 'fail',
                    idValue: "cloudTransfer"
                });
                return false;
            }
            commonUtils.submiTaskName(this);
        },
        //打开传输目标弹窗
        transferAimsDialogShow() {
            if (this.$store.state.isLiteMode) {
                this.$refs.tranToTree.show = true;
                return;
            }
            let that = this;
            //打开弹窗
            this.$refs.transferAimsDialog.taskSingleShow = true;
            //获取目标弹窗已选中的节点
            let checkedNodes = this.$refs.transferAimsDialog.checkedNodes;
            //将已选中节点存入缓存
            this.$store.commit('setClickItem', checkedNodes);
            //清空数据
            this.$store.state.syncClickItem = -1;
            this.$store.state.syncArr = [];
            this.$store.state.arr = [];
            //使滚动条回到原来的位置
            this.$nextTick(function () {
                that.$refs.transferAimsDialog.$refs.aimTree.scrollTop = that.$refs.transferAimsDialog.scrollTopValue;
            });
            //使滚动条回到原来的位置
            if (!checkedNodes || !checkedNodes.length) {
                let div = this.$refs.transferAimsDialog.$refs['elscrollbar'].wrap;//获取滚动条
                this.$forceUpdate();
                this.$nextTick(() => {
                    this.$refs.transferAimsDialog.$refs['elscrollbar'].wrap.scrollTop = 0;
                });
            }
            //标志为打开
            this.$store.commit("setTreeMoveSelect", true);
            this.$store.commit("setTransferFromOpen", false);
        },
        // 打开源目录弹窗
        transferSourceDialogShow() {
            if (this.$store.state.isLiteMode) {
                this.$refs.tranFromTree.show = true;
                return;
            }
            let that = this;
            this.$refs.transferSourceDialog.taskMultiShow = true;
            //获取源弹窗已选中的节点
            let checkedNodes = this.$refs.transferSourceDialog.checkedNodes;
            if (!checkedNodes) {
                checkedNodes = [];
            }
            if (!checkedNodes.length) {
                let div = this.$refs.transferSourceDialog.$refs['elscrollbar'].wrap;//获取滚动条
                this.$forceUpdate();
                this.$nextTick(() => {
                    this.$refs.transferSourceDialog.$refs['elscrollbar'].wrap.scrollTop = 0;
                });
            }
            this.$refs.transferSourceDialog.$refs.tree.setCheckedNodes(checkedNodes);
            //使滚动条回到原来的位置
            this.$nextTick(function () {
                that.$refs.transferSourceDialog.refresh();
            });
            this.$store.commit("setTransferFromOpen", true);
        },
        //删除多源选中框里的数据
        removeItem(index, id) {
            let that = this;
            //删除数据
            this.mulitDrives.splice(index, 1);
            //取消该项的选中
            this.$refs.transferSourceDialog.$refs.tree.setChecked(id, false);
            $.each(this.$refs.transferSourceDialog.checkedNodes, function (nodeIndex, nodeItem) {
                if (nodeItem.id == id) {
                    that.$refs.transferSourceDialog.checkedNodes.splice(nodeIndex, 1);
                    return false;
                }
            });
        },
        //打开设置弹窗
        openOptionsDialog() {
            if (this.$store.state.isLiteMode) {
                this.$refs.tranOptions.init();
                this.$refs.tranOptions.show = true;
                return;
            }
            //显示第一页
            this.$refs.transferOptionsDialog.activeName = "first";
            this.$refs.transferOptionsDialog.optionDialogShow = true;
            if (this.pOptions.keepRoot) {
                this.$refs.transferOptionsDialog.options.keepRoot = 1;
                this.$refs.transferOptionsDialog.$refs.tab1.checkArr.push(3);
            }
            if (!this.$refs.transferOptionsDialog.$refs.tab3.items.length) {
                this.$refs.transferOptionsDialog.$refs.tab3.radioCurrent = 0;
            }
        },
        //打开设置时间弹窗
        openSchduleDialog() {
            this.$refs.transferScheduleDialog.taskSchduleShow = true;
            this.$refs.transferScheduleDialog.initPopup();
        },
        //当用户取消选择时间设置时默认传参数为‘Now’
        checkedOpen() {
            if (this.checkedSchedule) {
                this.checkedSchedule = false;
                this.addTaskShow = false;
                this.pSchedules = {
                    type: "Now"
                }
                this.clearAllTableData();
            } else {
                this.openSchduleDialog();
            }
        },
        //清除界面数据
        clearAllTableData() {
            this.pSchedules = {
                type: "Now"
            }
            this.$refs.transferScheduleDialog.initPopup();
        },
        matchfileType(fileName) {
            return commonUtils.matchfileTypes(fileName);
        },
        // 发送Lite请求
        sendRequest(path, data, callback) {
            this.fullscreenLoading = true;
            requestUtils.doLiteRequest(path, data)
                .then(res => {
                    this.fullscreenLoading = false;
                    let code = res.code
                    let msg = res.msg
                    if (msg == undefined) {
                        msg = res.message;
                    }
                    if (code == 200) {
                        // 请求成功
                        if (callback) {
                            callback(res.data)
                        }
                    } else if (code == 400) {
                        // 请求失败
                        Message.warning(msg)
                    } else {
                        if (msg == "Unauthorized") {
                            // 未登录
                            location.href = location.host.includes("localhost") ? "http://localhost:8080/share/123" : "https://" + location.host + "/sign"
                        } else {
                            // 服务器异常
                            Message.error(msg)
                        }
                    }
                }, err => {
                    this.fullscreenLoading = false;
                    // 请求异常
                    Message.error(err)
                });
        },
        // 获取任务列表
        listTasks(callback) {
            this.sendRequest("/task/list", {}, (data) => {
                this.$store.state.tasks = data;
                if (callback) callback();
            })
        },
        transferNow() {
            if (this.$store.state.isLiteMode) {
                if (this.createTasking) return;
                if (!this.inputValue) {
                    Message.error("Please input task name");
                    return;
                }
                if (!this.liteSelectFromData) {
                    this.boxFrom = "box-shake";
                    setTimeout(() => {
                        this.boxFrom = "box-shakeOrigin";
                    }, 100);
                    return;
                }
                if (!this.liteSelectToData) {
                    this.boxTo = "box-shake";
                    setTimeout(() => {
                        this.boxTo = "box-shakeOrigin";
                    }, 100);
                    return;
                }
                const taskParam = {
                    type: "tran",
                    name: this.inputValue,
                    fdid: this.liteSelectFromData.did,
                    tdid: this.liteSelectToData.did,
                    param: {
                        from: this.liteSelectFromData.node,
                        to: this.liteSelectToData.node,
                        options: this.liteOptionsData,
                    }
                }
                // 开始创建任务
                let that = this;
                this.createTasking = true;
                this.sendRequest("/task/create", taskParam, () => {
                    taskListUtils.exeSuccessEnd('transferFlow', 'taskList', [], that);
                    this.liteSelectFromData = null;
                    this.liteSelectToData = null;
                    this.liteOptionsData = {
                        listThread: commonUtils.getUser().vip ? 3 : 1,
                        runThread: commonUtils.getUser().vip ? 10 : 2,
                        email: '',
                        cron: '',
                        sameName: 'default',
                        excludeNames: [],
                        allowedExtensions: [],
                    };
                    this.listTasks(() => {
                        const newTaskName = commonUtils.judgeRepeatTaskName([], that);
                        this.$refs.editInput.value = newTaskName;
                        this.inputValue = newTaskName;
                    });
                    this.createTasking = false;
                });
                return;
            }
            //判断是否是临时用户，然后提醒用户进行绑定邮箱
            let user = commonUtils.getUser();
            if (commonUtils.testUserIsTourist(user)) {
                this.$refs.remindBindEmailDialog.remindBindEmailShow = true;
                return false;
            }
            let that = this;
            var executeData;
            //如果用户流量不足，则显示付费升级弹窗
            let usedTraffic = user.usedBytes;
            // if(user.vip&&user.payLevel>1){
            //  usedTraffic = user.payUsedTraffic;
            // }
            if (user.totalBytes != -1 && usedTraffic >= user.totalBytes) {
                var upgradeNewDialog = this.$refs.upgradeNewDialog;
                upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_traffic');
                upgradeNewDialog.curItem = 'traffic';
                upgradeNewDialog.isShow = true;
                return false;
            }
            //如果用户源和目标都选择了
            if (this.mulitDrives.length && this.singleDrives.hasOwnProperty('name') &&this.singleDrives.name !== null) {
                let addData = new taskTransferUtils.addTaskData(user.id, 1, this.inputValue, taskTransferUtils.createTransferFromItems(this.mulitDrives), taskTransferUtils.createTransferToItems(this.singleDrives), this.pOptions, {
                    type: 'Now',
                    clientTime: commonUtils.getNowDateFormat(),
                });
                addData.options.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;//传时区
                if (!addData.n) {
                    this.$refs.editInput.cancelTaskName();
                    addData.n = this.$refs.editInput.oldNameValue;
                }
                //如果选择源的数量大于11条并且用户勾选了发送邮件，则出现提醒弹窗
                if (addData.fromItems.length >= 11 && addData.options.email) {
                    this.$refs.noticeDialog.noticeShow = true;
                    this.$refs.noticeDialog.transferFlag = 0;
                    this.$refs.noticeDialog.addData = addData;
                } else {
                    //开始传输数据
                    this.$nextTick(function () {
                        this.transferNowRequest(addData);
                    });
                }//如果未选择数据，div抖动
            } else if ((!this.mulitDrives.length && this.singleDrives.name !== null) || !this.mulitDrives.length) {
                this.boxFrom = "box-shake";
                setTimeout(() => {
                    this.boxFrom = "box-shakeOrigin";
                }, 100);
            } else if (!this.singleDrives.name) {
                this.boxTo = "box-shake";
                setTimeout(() => {
                    this.boxTo = "box-shakeOrigin";
                }, 100);
            }
        },
        //立即传输请求
        transferNowRequest(addData) {
            let that = this;
            if (that.addTaskFlag) {
                that.addTaskFlag = false;
                that.loading = true;
                //如果源数据大于200条，则显示弹框
                if (addData.fromItems.length > 200) {
                    that.$toast({
                        text: this.$t('language.cloudTransfer.sourceRemind'),
                        type: 'fail',
                        idValue: "cloudTransfer"
                    });
                    that.loading = false;
                    that.addTaskFlag = true;
                    return false;
                }
                //如果整体的未分组的数据超过5000，则显示弹窗
                if (this.$store.state.taskListNotGropArr.length >= 5000) {
                    that.$toast({
                        text: this.$t('language.exception.maxTaskRemind'),
                        type: 'fail',
                        idValue: "cloudTransfer"
                    });
                    that.loading = false;
                    that.addTaskFlag = true;
                    return false;
                }
                //iCloudPhotos文件夹作为目标，传输源不能选择文件，相簿作为目标，传输源不能选择文件夹
                if (addData.toItems.length > 0 && addData.toItems[0].driveType == "iCloudPhotos") {
                    let isForder = addData.toItems[0].docType == "FOLDER";
                    let isErr = false;
                    let errorTip;
                    if (addData.fromItems.length > 0) {
                        addData.fromItems.forEach(item => {
                            if (!item.isDir && isForder) {
                                //文件夹作为目标，禁止文件作为源
                                isErr = true;
                                errorTip = that.$t('language.exception.notSelectICloudPhotosRoot');
                                return false;
                            } else if (item.isDir && !isForder) {
                                //相簿为目标，禁止文件夹作为源
                                if (item.name == 'Favorites' || item.name == 'Hiddens' || item.name == 'Recents') {
                                    errorTip = that.$t('language.exception.notSelectICloudPhotosAlbum');
                                } else {
                                    errorTip = that.$t('language.exception.notSelectICloudPhotosAlbum');
                                }
                                isErr = true;
                                return false;
                            }

                        });
                        if (isErr) {
                            that.$toast({
                                text: errorTip,
                                type: 'note',
                                idValue: "cloudTransfer"
                            });
                            that.loading = false;
                            that.addTaskFlag = true;
                            return false;
                        }
                    }
                    //如果选择了所有文件都放在一个目录下，则报错
                    if (this.pOptions.keepRoot == 0) {
                        errorTip = that.$t('language.exception.onlySaveAlbums');
                        that.$toast({
                            text: errorTip,
                            type: 'note',
                            idValue: "cloudTransfer"
                        });
                        that.loading = false;
                        that.addTaskFlag = true;
                        return false;
                    }
                }
                //调用添加数据接口
                that.Utils.doTasksRequest('add', addData).then(res => {
                    that.addTaskFlag = true;
                    if (res.status == 200) {
                        //添加数据成功
                        taskListUtils.exeSuccessEnd('transferFlow', 'taskList', res.tasks, that);
                    } else {
                        that.loading = false;
                        that.$toast({
                            text: res.msg,
                            type: 'fail',
                            idValue: "cloudTransfer"
                        });
                    }
                });
            }
        },
        //仅仅添加传输任务
        transferAddTask() {
            //判断是否是临时用户，然后提醒用户进行绑定邮箱
            let user = commonUtils.getUser();
            if (commonUtils.testUserIsTourist(user)) {
                this.$refs.remindBindEmailDialog.remindBindEmailShow = true;
                return false;
            }
            if (this.mulitDrives.length && this.singleDrives.name) {
                let that = this;
                //流量不足弹窗提醒
                let usedTraffic = user.usedBytes;
                //  if(user.vip&&user.payLevel>1){
                //      usedTraffic = user.payUsedTraffic;
                //   }
                if (user.totalBytes != -1 && usedTraffic >= user.totalBytes) {
                    var upgradeNewDialog = this.$refs.upgradeNewDialog;
                    upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_traffic');
                    upgradeNewDialog.curItem = 'traffic';
                    upgradeNewDialog.isShow = true;
                    return false;
                }
                let addData = new taskTransferUtils.addTaskData(user.id, 1, this.inputValue, taskTransferUtils.createTransferFromItems(this.mulitDrives), taskTransferUtils.createTransferToItems(this.singleDrives), this.pOptions, this.pSchedules);
                addData.options.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;//传时区
                //添加的源数据不能超过200条
                if (addData.fromItems.length > 200) {
                    that.$toast({
                        text: this.$t('language.cloudTransfer.sourceRemind'),
                        type: 'fail',
                        idValue: "cloudTransfer"
                    });
                    that.loading = false;
                    return false;
                }
                if (this.$store.state.taskListNotGropArr.length >= 5000) {
                    that.$toast({
                        text: this.$t('language.exception.maxTaskRemind'),
                        type: 'fail',
                        idValue: "cloudTransfer"
                    });
                    that.loading = false;
                    return false;
                }
                //iCloudPhotos文件夹作为目标，传输源不能选择文件，相簿作为目标，传输源不能选择文件夹
                if (addData.toItems.length > 0 && addData.toItems[0].driveType == "iCloudPhotos") {
                    let isForder = addData.toItems[0].docType == "FOLDER";
                    let isErr = false;
                    let errorTip;
                    if (addData.fromItems.length > 0) {
                        addData.fromItems.forEach(item => {
                            if (!item.isDir && isForder) {
                                //文件夹作为目标，禁止文件作为源
                                isErr = true;
                                errorTip = that.$t('language.exception.notSelectICloudPhotosRoot');
                                return false;
                            } else if (item.isDir && !isForder) {
                                //相簿为目标，禁止文件夹作为源
                                if (item.name == 'Favorites' || item.name == 'Hiddens' || item.name == 'Recents') {
                                    errorTip = that.$t('language.exception.notSelectICloudPhotosAlbum');
                                } else {
                                    errorTip = that.$t('language.exception.notSelectICloudPhotosAlbum');
                                }
                                isErr = true;
                                return false;
                            }

                        });
                        if (isErr) {
                            that.$toast({
                                text: errorTip,
                                type: 'note',
                                idValue: "cloudTransfer"
                            });
                            that.loading = false;
                            that.addTaskFlag = true;
                            return false;
                        }
                    }
                    //如果选择了所有文件都放在一个目录下，则报错
                    if (this.pOptions.keepRoot == 0) {
                        errorTip = that.$t('language.exception.onlySaveAlbums');
                        that.$toast({
                            text: errorTip,
                            type: 'note',
                            idValue: "cloudTransfer"
                        });
                        that.loading = false;
                        that.addTaskFlag = true;
                        return false;
                    }
                }
                if (!addData.n) {
                    this.$refs.editInput.cancelTaskName();
                    addData.n = this.$refs.editInput.oldNameValue;
                }
                if (addData.fromItems.length >= 11 && addData.options.email) {
                    this.$refs.noticeDialog.noticeShow = true;
                    this.$refs.noticeDialog.transferFlag = 1;
                    this.$refs.noticeDialog.addData = addData;
                } else {
                    this.$nextTick(function () {
                        this.doAddTasksRequest(addData);
                    });
                }
            } else if ((!this.mulitDrives.length && !this.singleDrives.name) || !this.mulitDrives.length) {
                this.boxFrom = "box-shake";
                setTimeout(() => {
                    this.boxFrom = "box-shakeOrigin";
                }, 100);
            } else if (!this.singleDrives.name) {
                this.boxTo = "box-shake";
                setTimeout(() => {
                    this.boxTo = "box-shakeOrigin";
                }, 100);
            }
        },
        //添加传输任务并立即执行
        addTransferNow() {
            //判断是否是临时用户，然后提醒用户进行绑定邮箱
            let user = commonUtils.getUser();
            if (commonUtils.testUserIsTourist(user)) {
                this.$refs.remindBindEmailDialog.remindBindEmailShow = true;
                return false;
            }
            if (this.mulitDrives.length && this.singleDrives.name) {
                let that = this;
                //流量不足弹窗提醒
                let usedTraffic = user.usedBytes;
                // if(user.vip&&user.payLevel>1){
                //  usedTraffic = user.payUsedTraffic;
                // }
                if (user.totalBytes != -1 && usedTraffic >= user.totalBytes) {
                    var upgradeNewDialog = this.$refs.upgradeNewDialog;
                    upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_traffic');
                    upgradeNewDialog.curItem = 'traffic';
                    upgradeNewDialog.isShow = true;
                    return false;
                }
                let addData = new taskTransferUtils.addTaskData(user.id, 1, this.inputValue, taskTransferUtils.createTransferFromItems(this.mulitDrives), taskTransferUtils.createTransferToItems(this.singleDrives), this.pOptions, this.pSchedules);
                addData.options.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;//传时区
                if (addData.fromItems.length > 200) {
                    that.$toast({
                        text: this.$t('language.cloudTransfer.sourceRemind'),
                        type: 'fail',
                        idValue: "cloudTransfer"
                    });
                    that.loading = false;
                    return false;
                }
                if (this.$store.state.taskListNotGropArr.length >= 5000) {
                    that.$toast({
                        text: this.$t('language.exception.maxTaskRemind'),
                        type: 'fail',
                        idValue: "cloudTransfer"
                    });
                    that.loading = false;
                    return false;
                }

                if (!addData.n) {
                    this.$refs.editInput.cancelTaskName();
                    addData.n = this.$refs.editInput.oldNameValue;
                }
                if (addData.fromItems.length >= 11 && addData.options.email) {
                    this.$refs.noticeDialog.noticeShow = true;
                    this.$refs.noticeDialog.transferFlag = 2;
                    this.$refs.noticeDialog.addData = addData;
                } else {
                    this.$nextTick(() => {
                        this.addTaskAndTransferNowRequest(addData);
                    });
                }
            } else if ((!this.mulitDrives.length && !this.singleDrives.name) || !this.mulitDrives.length) {
                this.boxFrom = "box-shake";
                setTimeout(() => {
                    this.boxFrom = "box-shakeOrigin";
                }, 100);
            } else if (!this.singleDrives.name) {
                this.boxTo = "box-shake";
                setTimeout(() => {
                    this.boxTo = "box-shakeOrigin";
                }, 100);
            }
        },
        //添加任务并立即传输请求
        addTaskAndTransferNowRequest(addData) {
            let that = this;
            let executeData;
            if (that.addTaskFlag) {
                that.addTaskFlag = false;
                that.Utils.doTasksRequest('add', addData).then(res => {
                    that.addTaskFlag = true;
                    if (res.status == 200) {
                        if (res.group_id) {
                            executeData = new taskListUtils.executeData(commonUtils.getUser().id, 1, null, res.group_id);
                        } else {
                            executeData = new taskListUtils.executeData(commonUtils.getUser().id, 1, res.tasks[0].id, null);
                        }
                        taskListUtils.addLength(this);
                        that.doExeCuteTasksRequest(executeData, res.tasks);
                        that.checkedSchedule = false;
                    } else {
                        that.$toast({
                            text: res.msg,
                            type: 'fail',
                            idValue: "cloudTransfer"
                        });
                    }
                });
            }
        },
        doAddTasksRequest(addData) {
            let that = this;
            if (that.addTaskFlag) {
                that.loading = true;
                that.addTaskFlag = false;
                that.Utils.doTasksRequest('add', addData).then(res => {
                    that.addTaskFlag = true;
                    if (res.status == 200) {
                        taskListUtils.exeSuccessEnd('transferFlow', 'taskList', res.tasks, that);
                    } else {
                        that.loading = false;
                        that.$toast({
                            text: res.msg,
                            type: 'fail',
                            idValue: "cloudTransfer"
                        });
                    }
                });
            }
        },
        doExeCuteTasksRequest(executeData, tasks) {
            let that = this;
            if (that.addTaskFlag) {
                that.loading = true;
                that.addTaskFlag = false;
                that.Utils.doTasksRequest('execute', executeData).then(res => {
                    that.addTaskFlag = true;
                    if (res.status == 200) {
                        $.each(tasks, function (i, item) {
                            item.status = 'Waiting';
                        });
                        taskListUtils.exeSuccessEnd('transferFlow', 'taskList', tasks, that);
                    } else {
                        that.loading = false;
                        that.$toast({
                            text: res.msg,
                            type: 'fail',
                            idValue: "cloudTransfer"
                        });
                    }
                });
            }
        },
        clearPageChoose() {
            let that = this;
            that.mulitDrives = [];
            that.singleDrives = {};
            that.hasSelectItemsMore = false;
            that.hasSelectItems = false;
            that.hasSelect = true;
            that.checkedSchedule = false;
            that.addTaskShow = false;
            let sourceDialog = that.$refs.transferSourceDialog;
            let aimDialog = that.$refs.transferAimsDialog;
            sourceDialog.checkedNodes = [];
            that.$refs.transferAimsDialog.checkedNodes = [];
            that.$store.state.syncClickItem = -1;
            that.$store.state.clickItem = -1;
            that.$store.state.syncArr = [];
            that.$store.state.arr = [];
            //收拢两个树形弹窗
            for (var i = 0; i < sourceDialog.$refs.tree.store._getAllNodes().length; i++) {
                sourceDialog.$refs.tree.store._getAllNodes()[i].expanded = false;
            }
            commonUtils.closeTree(aimDialog.model);
            let div1 = sourceDialog.$refs['elscrollbar'].wrap;
            let div2 = aimDialog.$refs['elscrollbar'].wrap;
            that.$nextTick(() => {
                div1.scrollTop = 0;
                div2.scrollTop = 0;
            });
            sourceDialog.scrollTopValue = 0;
            aimDialog.scrollTopValue = 0
            that.$refs.transferOptionsDialog.clearAllData();
            this.clearAllTableData();
        },

    }
};
</script>

<style>
.transfer-right-body {
    width: 100%;
    height: calc(100% - 90px);
    /*no*/
    background-color: #f2f7fe !important;
    position: relative;
    top: 90Px;
    overflow-x: hidden;
}

/*定义滑块，内阴影及圆角*/

.transfer-right-body::-webkit-scrollbar {
    width: 9px;
    /*no*/
    height: 9px;
    /*no*/
    background-color: #fff;
}

.transfer-right-body::-webkit-scrollbar-thumb {
    height: 1px;
    /*no*/
    border-radius: 5px;
    /*no*/
    background-color: #becae4;
}

#cloudTransfer .el-loading-spinner i {
    color: #999999;
}

#cloudTransfer .el-loading-spinner {
    font-size: 45px;
    /*no*/
}
</style>



// WEBPACK FOOTER //
// src/components/workspace/cloud_transfer.vue